import { enableProdMode } from "@angular/core";
import { platformBrowserDynamic } from "@angular/platform-browser-dynamic";
import { AppModule } from "./app/app.module";
import "@upmc-healthplan-npm/ods-wc";

// Suppress ODS Web Components DOM validation warnings about duplicate IDs
const originalWarn = console.warn;
console.warn = function (...args) {
  if (
    args[0]?.includes?.("[DOM] Found") ||
    args[0]?.includes?.("non-unique id")
  ) {
    return; // Suppress these specific warnings
  }
  originalWarn.apply(console, args);
};

fetch("./assets/config.json")
  .then((response) => response.json())
  .then((config: any) => {
    window["ENVIRONMENT"] = Object.assign({}, config.environment);
    window["OAUTH_CONFIG"] = Object.assign({}, config.oauth);

    if (config.environment.production) {
      enableProdMode();
    }

    platformBrowserDynamic()
      .bootstrapModule(AppModule)
      .catch((err) => console.error(err));
  })
  .catch((_) => window.location.reload());
